import type { SVGProps } from 'react';

/**
 * OpenCode icon - a terminal/code style icon representing the opencode agent.
 */
const OpenCodeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {/* Terminal window frame */}
    <rect x="2" y="3" width="20" height="18" rx="2" />
    {/* Terminal prompt */}
    <polyline points="8 10 5 13 8 16" />
    {/* Cursor/code */}
    <line x1="12" y1="10" x2="19" y2="10" />
    <line x1="12" y1="14" x2="16" y2="14" />
  </svg>
);

export { OpenCodeIcon };
